const getProjectName = () => window.location.pathname.split('/')[1].toLowerCase();

export default getProjectName();
